import React from 'react'
import PropTypes from 'prop-types'

import Glyph from 'component/utils/Glyph'

const Table = ({
  handleDelete,
  handleUpdate,
  handleView,
  records,
  translate,
}) => {
  const renderHeader = () => (
    <thead>
      <tr>
        <th>{translate('config.pricebannerConfig.tableHeader.dsDynamic')}</th>
        <th>{translate('config.pricebannerConfig.tableHeader.dsCard')}</th>
        <th>{translate('config.pricebannerConfig.tableHeader.nuRange')}</th>
        <th>{translate('config.pricebannerConfig.tableHeader.dtPeriod')}</th>
        <th className='text-align-center'>
          {translate('config.pricebannerConfig.tableHeader.view')}
        </th>
        <th className='text-align-center'>
          {translate('config.pricebannerConfig.tableHeader.edit')}
        </th>
        <th className='text-align-center'>
          {translate('config.pricebannerConfig.tableHeader.remove')}
        </th>
      </tr>
    </thead>
  )

  const renderBody = () => <tbody>{records.map(renderRow)}</tbody>

  const renderRow = (row) => (
    <tr key={row.cdPricebannerConfig}>
      <td>{row.dsDynamic}</td>
      <td>{row.dsCard}</td>
      <td>{row.nuRange}</td>
      <td>{row.dsPeriod}</td>
      <td>
        <Glyph
          color='primary'
          customClass='table-icon'
          type='eye'
          onClick={() => handleView(getOpenModalValue(row))}
        />
      </td>
      <td>
        <Glyph
          color='primary'
          customClass='table-icon'
          type='pencil'
          onClick={() => handleUpdate(getOpenModalValue(row))}
        />
      </td>
      <td>
        <Glyph
          color='danger'
          customClass='table-icon'
          type='trash-can'
          onClick={() => handleDelete(getOpenModalValue(row))}
        />
      </td>
    </tr>
  )

  const getOpenModalValue = (record) => ({ open: true, record })

  return (
    <table cellPadding={0} cellSpacing={0}>
      {renderHeader()}
      {renderBody()}
    </table>
  )
}

Table.propTypes = {
  handleDelete: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  handleView: PropTypes.func.isRequired,
  records: PropTypes.array.isRequired,
  translate: PropTypes.func.isRequired,
}

export default Table
